module.exports = __webpack_public_path__ + "img/arsenal.cf570c72.png";